import { handleActions } from 'redux-actions'

import { deletePatientData } from 'src/store/modules/actionCreators'
import {
  clearAlertsPriorityCount,
  resetAlerts,
  setAlertPatientUuid,
  setAlertPredefinedFilters,
  setAlertTypes,
  setAlertsByCaseManagers,
  setAlertsByFacilities,
  setAlertsForDashboard,
  setAlertsPriorityCount,
  setIsAlertRedirectFromDashboard,
  setNewAlertsCount,
  setPatientAlertList
} from 'src/store/modules/alerts'

const initialState = {
  // Alerts Details
  types: [],
  newAlertsCount: 0,
  alertsPriorityCount: {},
  isAlertRedirectedFromDashboard: false,
  predefinedFilters: {},
  patientAlertList: [],
  alertPatientUuid: '',
  // Alerts Dashboard
  dashboardData: [],
  dashboardAlertsByCaseManagers: [],
  dashboardAlertsByFacilities: []
}

export default handleActions(
  {
    [setAlertTypes](state, { payload = [] }) {
      return {
        ...state,
        types: payload
      }
    },

    [setNewAlertsCount](state, { payload: newAlertsCount }) {
      return {
        ...state,
        newAlertsCount
      }
    },

    [setAlertsPriorityCount](state, { payload: alertsPriorityCount }) {
      return {
        ...state,
        alertsPriorityCount
      }
    },

    [clearAlertsPriorityCount](state) {
      return {
        ...state,
        alertsPriorityCount: {}
      }
    },

    [setIsAlertRedirectFromDashboard](
      state,
      { payload: isAlertRedirectedFromDashboard }
    ) {
      return {
        ...state,
        isAlertRedirectedFromDashboard
      }
    },

    [setAlertPredefinedFilters](state, { payload: predefinedFilters }) {
      return {
        ...state,
        predefinedFilters
      }
    },

    [setPatientAlertList](state, { payload: patientAlertList }) {
      return {
        ...state,
        patientAlertList
      }
    },

    [setAlertPatientUuid](state, { payload: alertPatientUuid }) {
      return {
        ...state,
        alertPatientUuid
      }
    },

    [deletePatientData](state) {
      return {
        ...state,
        patientAlertList: []
      }
    },

    [resetAlerts]({ newAlertsCount }) {
      return {
        ...initialState,
        newAlertsCount
      }
    },

    [setAlertsForDashboard](state, { payload: dashboardData }) {
      return {
        ...state,
        dashboardData
      }
    },

    [setAlertsByCaseManagers](
      state,
      { payload: dashboardAlertsByCaseManagers }
    ) {
      return {
        ...state,
        dashboardAlertsByCaseManagers
      }
    },

    [setAlertsByFacilities](state, { payload: dashboardAlertsByFacilities }) {
      return {
        ...state,
        dashboardAlertsByFacilities
      }
    }
  },
  initialState
)
